<template>
  <div class="redeems">
    <ag-table :data-source-api="getAllRedeemRewards" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitAddNewRecord="onRedeemReward()" />
    <tm-popup :submit="onRedeemRewardPopupSubmit" :title="redeemPopupTitle" ref="redeemPopup">
      <div class="vx-row justify-start">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getClientsOptions" label="name" validation-rules="required"
            name="اسم المستخدم" :reduce="name => name.value" v-model="redeem.clientId" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getRewardOptions" label="name" validation-rules="required"
            name="المكافأة" :reduce="name => name.value" v-model="redeem.rewardId" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AgTableBtnCell from "../../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "../../../shared/shared-components/ag-grid/AgButton";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import utilities from '@/app/shared/utilities/index';

const redeemRepo = RepositoryFactory.get('redeemRepository');
const clientsRepo = RepositoryFactory.get('clientsRepository');
const rewardsRepo = RepositoryFactory.get('rewardsRepository');

export default {
  name: "Redeem",
  components: {
    AgTable,
    AgTableBtnCell,
    TmPopup,
    AgButton,
    TmSelect
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      redeemPopupTitle: '',
      rewards: [],
      clients: [],
      redeem: {
        clientId: null,
        rewardId: null
      },
      permissions: {
          add: 'rewards_manage',
          edit: 'rewards_manage',
          delete: 'rewards_manage',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'اسم المستخدم',
          field: 'clientId',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: false,
          valueGetter:
            function getObject(data) {
              return data.data.client.name;
            },
        },
        {
          headerName: 'الجائزة',
          field: 'rewardId',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: false,
          valueGetter:
            function getObject(data) {
              return data.data.reward.name;
            },
        },
        {
          headerName: 'نقاط الاستبدال',
          field: 'rewardPoints',
          filter: 'agNumberColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'تاريخ الاستبدال',
          field: 'createdAt',
          width: 200,
          sortable: false,
          valueGetter:
            function getObject(data) {
              return utilities.formatDate(data.data.createdAt, 'yyyy-MM-DD');
            },
        },
      ];
    },
    onRedeemReward() {
      this.redeemPopupTitle = 'إضافة استبدال جديد';
      this.resetRedeemRewardForm();
      this.$refs.redeemPopup.open();
    },
    resetRedeemRewardForm() {
      Object.assign(this.redeem, {
        clientId: null,
        rewardId: null
      });
    },
    async onRedeemRewardPopupSubmit() {
      try {
        const res = await redeemRepo.redeemReward(this.redeem);
        if (res.status === 201 || res.status === 200) {
          this.$refs.redeemPopup.close();
          await this.gridApi.refreshServerSideStore({ purge: true });
        }
      } catch (err) {
        this.$refs.redeemPopup.endLoading();
      }
    },
    async getAllRedeemRewards(query) {
      return await redeemRepo.fetchRedeemRewards(query);
    },
    async getAllClients() {
      const res = await clientsRepo.fetchClients();
      this.clients = res.data;
    },
    async getAllRewards() {
      const res = await rewardsRepo.fetchRewards('?filter=status||$eq||active');
      this.rewards = res.data;
    },
    modifyResource(data) {
      return data.map(item => ({
        name: item.name,
        value: item.id
      }));
    },
  },
  computed: {
    getRewardOptions() {
      return this.modifyResource(this.rewards);
    },
    getClientsOptions() {
      return this.modifyResource(this.clients);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.getAllClients();
    this.getAllRewards();
  }
};
</script>